import { notifyAuthExpired } from "./authSession";

const API_BASE = import.meta.env.VITE_API_URL || "/api";

export class ApiError extends Error {
  constructor(message, status, data = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

async function request(method, path, body = null) {
  const token = localStorage.getItem("anna_token");
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const options = { method, headers };
  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(`${API_BASE}${path}`, options);

  if (!response.ok) {
    if (response.status === 401) {
      notifyAuthExpired("unauthorized");
    }
    const error = await response.json().catch(() => ({}));
    throw new ApiError(error.message || `HTTP ${response.status}`, response.status, error);
  }

  return response.json();
}

export const apiClient = {
  get: (path) => request("GET", path),
  post: (path, body) => request("POST", path, body),
  put: (path, body) => request("PUT", path, body),
  patch: (path, body) => request("PATCH", path, body),
  delete: (path) => request("DELETE", path),
  request: (path, opts = {}) => request(opts.method || "GET", path, opts.body || null),
};
